import { MatSort } from '@angular/material/sort';
import { Title } from '@angular/platform-browser';
import {Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MatTableDataSource } from '@angular/material/table';
import { UrlQueryDef } from 'src/app-client/_appCommon/base/UrlQueryDef';
import { CaseDataService } from '../../../_dataservices/CaseDataService';
import { AppClientContext } from '../../../_appCommon/base/AppClientContext';
import { ListControllerBase } from '../../../_appCommon/base/ListControllerBase';
import { CustomerDataService } from '../../../_dataservices/CustomerDataService';
import { DynamicPipeType } from '../../../_appCommon/base/AppInterfaceAndBaseClasses';
import { Tools } from 'src/app-client/_appCommon/util/Tools';
import { StatusDataService } from 'src/app-client/_dataservices/StatusDataService';
import { MatPaginator } from '@angular/material/paginator';

export interface MatTableOrderBy {
  columnName :string,
  direction : string
}

@Component({
  selector: 'app-case-list',
  templateUrl: './case-list.component.html',
  styleUrls: ['./case-list.component.css'],
  providers: [CaseDataService, CustomerDataService]
})

export class CaseListComponent extends ListControllerBase<CaseDataService>
{
  @ViewChild('table') protected table: any;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('paginator') paginator!: MatPaginator;

  public customerCases: any[];
  public customerId: number;
  public dataSource: MatTableDataSource<any>;

  public isLoading = false;

  public searchByPatient: string = "";
  public searchByStatusType: string = "0";
  public searchValueById: string = "";
  public statusOptions: any[] = [];

  public displayedColumns: any[] = [
    { property: 'code', display: 'Código', pipe: null },
    { property: 'patientFullName', display: 'Datos del paciente', pipe: null },
    { property: 'patientEmail', display: 'Correo electrónico', pipe: null },
    { property: 'totalAligners', display: 'Alineadores comprados', pipe: null },
    { property: 'usedAligners', display: 'Alineadores usados', pipe: null },
    { property: 'alignersToFinishCase', display: 'Alineadores por terminar el caso', pipe: null },
    { property: 'productName', display: 'Producto', pipe: null },
    { property: 'statusDescriptionEcommerce', display: 'Estatus', pipe: null },
    { property: 'createdDate', display: 'Fecha de Alta', pipe: DynamicPipeType.DateTime },
    { property: '', display: 'Acciones', pipe: null }
  ];

  public columnsToDisplay: any[] = this.displayedColumns.map(col => col.display);

  public matTableOrderBy :MatTableOrderBy;

  constructor(title: Title,
    caseDataService: CaseDataService,
    private router: Router,
    private customerDataService: CustomerDataService,
    private statusDataService: StatusDataService)
  {
    super("Casos", title, caseDataService);
  }

  ngOnInit()
  {
    this.isLoading = true;
    this.getCustomerInfo();
    super.ngOnInit();
    this.getAllStatus();
  }

  onSortChange(sortEvent: any): void {
    if (sortEvent.direction == '')
    {
      this.matTableOrderBy = null;
    }
    else
    {
      this.matTableOrderBy = { columnName: sortEvent.active, direction: sortEvent.direction };
    }
    this.getAll();
  }

  public getAllStatus(): void
  {
    let queryDef = new UrlQueryDef();
    this.statusDataService.get(queryDef).subscribe((response: any) =>
    {
      this.statusOptions.push({ "name": "Todas los status", "value": 0 });
      for (let i = 0; i < response.rows.length; i++)
      {
        this.statusOptions.push({
          "name": response.rows[i].name,
          "value": response.rows[i].id
        });
      }
    }, (fail: any) =>
    {
      this.setWarningAlert(fail.error.message);
    });
  }

  public getCustomerInfo()
  {
    if (AppClientContext.Instance.customerId)
    {
      this.customerId = AppClientContext.Instance.customerId;
      if (this.pagination)
      {
        this.pagination.getPage(this.pagination.pageNumber, this.pagination.pageSize)
          .subscribe(response =>
          {
            this.onAfterGetAll();
          });
      }
    }
    else
    {
      this.router.navigate(['/ecommerce']);
    }
  }

  public onCreateNewCase(): void
  {
    this.router.navigate(['/ecommerce/mis-casos/nuevo-caso/paciente'],{queryParams: {'newCase': true}});
  }

  protected onSelect(item: any): void
  {
    if (item.isPartialSave)
      this.router.navigate(['/ecommerce/mis-casos/nuevo-caso/paciente/'+item.patientId], {queryParams: {'caseId': item.id}});
  }

  protected onGoToFileCorrection(item:any): void
  {
    this.router.navigate(['/ecommerce/mis-casos/file-correction', item.id]);
  }

  public getBackgroundColor(columnName: string, element: any): string
  {
    return columnName === 'Estatus' ? element['statusColor'] : 'transparent';
  }

  public getColor(columnName: string, element: any): string
  {
    return columnName === 'Estatus' && element['statusColor'] != 'transparent' ? '#fff' : '#333';
  }

  // ********************************************************************************
  // #region Methods Overrides
  // ********************************************************************************
  protected onRegisterEventListeners()
  {
    super.onRegisterEventListeners();
  }


  public override getAll(paged: boolean = false,  matOrderActivated: boolean = false): void
  {
    this.onBeforeGetAll();

    /*if (this.isPagingActive)
    {
      this.updatePaginationData();
      return;
    }*/

    this.dataService.getAllCasesFiltered(this.getQueryDefForGetAll(matOrderActivated))
      .subscribe((response: any) =>
      {
        //Check if we have a paged result
        if (response.records != undefined && response.totalRecords != undefined)
        {
          this.dataRows = response.records;
          this.totalRows = response.totalRecords;
          
        }
        else
        {
          this.dataRows = response;
        }

        if (this.paginator && !paged)
          this.paginator.firstPage();

        this.dataRowsCopy = this.dataRows;
        this.onAfterGetAll();
      });
  }

  protected override onAfterGetAll()
  {
    this.dataSource = new MatTableDataSource<any>(this.dataRows);
    this.dataSource.sortingDataAccessor = Tools.sortingDataAccessor;
    this.dataSource.sort = this.sort;
    this.isLoading = false;

    //super.onAfterGetAll();
  }

  protected onGetQueryDefForGetAll(queryDef: UrlQueryDef, matOrderActivated: boolean = false)
  {
    queryDef.params = {};

    if(this.paginator && !matOrderActivated){
      queryDef.params['pageNo'] = this.paginator.pageIndex + 1;
      queryDef.params['pageSize'] = this.paginator.pageSize;
    }
    else if(this.paginator && matOrderActivated)
    {
      queryDef.params['pageNo'] = 1;
      queryDef.params['pageSize'] = this.paginator.pageSize;
    }

    queryDef.params['isDeleted'] = false;

    queryDef.params['requestFrom'] = 2;
    if (this.customerId)
    {
      queryDef.params['customerId'] = this.customerId;
    }

    //Filter by Id
    if (this.searchValueById != "" && !this.searchValueById.includes("C-AW"))
    {
      queryDef.params['id'] = this.searchValueById;
    }

    //Filter by code
    if (this.searchValueById != "" && this.searchValueById.includes("C-AW")) 
    {
      queryDef.params['code'] = this.searchValueById;
    }

    //Filter by Patient
    if (this.searchByPatient != "")
    {  
        queryDef.params['customerPatientFullName'] = this.searchByPatient;
    }

    //Filter by status
    if (this.searchByStatusType != "0")
    {
        queryDef.params['statusId'] = this.searchByStatusType;
    }

    if(this.matTableOrderBy){
      queryDef.params['matTableOrderBy'] = JSON.stringify(this.matTableOrderBy);
    }

    super.onGetQueryDefForGetAll(queryDef);
  }

  protected override getQueryDefForGetAll(matOrderActivated: boolean = false): UrlQueryDef
  {
    var queryDef = new UrlQueryDef();

    this.onGetQueryDefForGetAll(queryDef, matOrderActivated);

    return queryDef;
  }

  public onGetFilteredResults(): void
  {
    this.pagination.setPageNumber = 0;
    this.getAll();
  }
}
